const root = "_root_jbbqu_1";
const styles = {
	root: root
};

export { styles as s };
//# sourceMappingURL=Symbol.module-CLfqmFso.mjs.map
